import { svg } from "../svg";

export const VowkeyLogo = svg`
  <svg viewBox="0 0 272 44" xmlns="http://www.w3.org/2000/svg">
    <title>Vowkey</title>
    <g transform="translate(0 2.6)"><svg width="50" height="37.5" viewBox="12 22 96 72">
      <path d="M70 40H93a9 9 0 0 1 9 9v28a9 9 0 0 1-9 9H27a9 9 0 0 1-9-9V49a9 9 0 0 1 9-9h1" fill="none" stroke-width="7" stroke-linecap="round" style="stroke: var(--vk-ink, rgb(var(--color-text-main)))"/>
      <rect x="31" y="28" width="34" height="23" rx="5" style="fill: var(--vk-blue, #2563EB)"/>
      <rect x="37.5" y="37.75" width="21" height="3.5" rx="1.75" fill="#fff"/>
      <g style="fill: var(--vk-ink, rgb(var(--color-text-main)))"><circle cx="35" cy="65" r="5"/><circle cx="51" cy="65" r="5"/><circle cx="67" cy="65" r="5"/></g>
      <rect x="80" y="54" width="5.5" height="22" rx="2.75" style="fill: var(--vk-blue, #2563EB)"/>
    </svg></g>
    <text x="56" y="32.2" font-family="'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" font-size="30.5" font-weight="700" letter-spacing="-0.75" style="fill: var(--vk-ink, rgb(var(--color-text-main)))">Vowkey</text>
  </svg>
`;
